import { TextLatoProps } from './TextLato.types';

export enum TextLatoConversionKeys {
  BOLD = 'bold',
  ITALIC = 'italic',
}

export const TEXT_LATO_CONVERSION_STYLE_MAP: Record<TextLatoConversionKeys, TextLatoProps['style']> = {
  [TextLatoConversionKeys.BOLD]: { fontWeight: '700' as const },
  [TextLatoConversionKeys.ITALIC]: { fontStyle: 'italic' as const },
};
